import { call, Effect, put, select, takeLatest } from "redux-saga/effects"
import { ActionCreators } from "redux-undo"
import { get } from "lodash"

import ActionTypes from "~/enums/ActionTypes"
import { createAction } from "~/utils/redux"
import { checkTokenAndRedirect, doAPIRequest } from "../api"
import { getSimulationId, getState, getUserData } from "../selectors"
import { post } from "~/utils/http"
import { API_SERVER_PLANNING_PROCESS } from "~/constants/api"
import { AuthenticationState } from "~/types/ReduxStateExtensions"
import { TimelineSagaResponse, TimelineSagaState } from "./TimelineSagaTypes"

import { User } from "~/types/api/UserTypes"
import { addOwner } from "~/reducers/timeline/helpers/addOwner"

const endPointFetchProjects = `${API_SERVER_PLANNING_PROCESS}/getTimelineDataByProjectIds`

function* updateTimelineProjects(action: Effect<string, { projectIds: number[] }>) {
  const affectedProjects = action.payload
  const state = (yield select(getState)) as TimelineSagaState
  const { token } = (yield select(getUserData)) as AuthenticationState
  const simulationId: unknown = yield select(getSimulationId)

  try {
    let resp = null
    resp = (yield doAPIRequest({
      endPoint: endPointFetchProjects,
      method: post,
      prepareRequest: () => affectedProjects,
      token,
      state: { simulation: { id: simulationId } },
      payload: null,
      prepareResponse: null,
      prepareUrl: null,
    })) as TimelineSagaResponse

    const { projects: fetchedProjects, versionIdentifier } = resp

    const users: User[] = get(state, "entities.users")
    const projects = addOwner(fetchedProjects, users)

    yield put(
      createAction(ActionTypes.TIMELINE_UPDATE_PROJECTS, {
        projects,
        affectedProjects: affectedProjects.projectIds,
        users,
      })
    )
    yield put(
      createAction(ActionTypes.TIMELINE_VERSION_UPDATE, {
        versionIdentifier,
      })
    )
  } catch (e) {
    const skipErrorHandling: unknown = yield call(checkTokenAndRedirect, e)
    if (skipErrorHandling) {
      return
    }

    yield put(ActionCreators.undo())
  }
}

export default [takeLatest(ActionTypes.TIMELINE_DATA_FETCH_PROJECTS, updateTimelineProjects)]
